import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '8px',
      paddingBlock: '16px',
    },
  });
